<template>
    <div>
      <div class="row">
        <div class="col_12">
          <div class="card border_none">
            <div class="card_body pl_0 pr_0">
              <div class="row">
                <div class="col_6 pr_20">
                  <div :class="['form_row', {'has_error': errorFor('name')}]">
                    <label class="required">Name</label>
                    <div class="form_inline">
                      <input type="text" class="form_global" v-model="contact.name">
                      <v-errors :errors="errorFor('name')"></v-errors>
                    </div>
                  </div>
                  <div :class="['form_row', {'has_error': errorFor('email')}]">
                    <label class="required">Email</label>
                    <div class="form_input">
                      <input type="email" class="form_global" v-model="contact.email">
                      <v-errors :errors="errorFor('email')"></v-errors>
                    </div>
                  </div>
                  <div :class="['form_row', {'has_error': errorFor('title')}]">
                    <label>Title</label>
                    <div class="form_inline">
                      <input type="text" class="form_global" v-model="contact.title">
                      <v-errors :errors="errorFor('title')"></v-errors>
                    </div>
                  </div>
                </div>
                <div class="col_6 pl_20">
<!--                  <div :class="['form_row', {'has_error': errorFor('status')}]">
                    <label class="required">Status</label>
                    <div class="form_radio">
                      <input type="radio" id="statusActive" v-model="contact.status" value="1">
                      <label for="statusActive">Active</label>
                    </div>
                    <div class="form_radio">
                      <input type="radio" id="statusInactive" v-model="contact.status" value="0">
                      <label for="statusInactive">Inactive</label>
                    </div>
                    <v-errors :errors="errorFor('status')"></v-errors>
                  </div>-->
                  <div class="row">
                    <div class="col_9">
                      <div :class="['form_row', {'has_error': errorFor('company_id')}]">
                        <label>Company</label>
                        <div class="form_input">
                          <select class="form_global" v-model="contact.company_id">
                            <option value="">Select Company</option>
                            <option v-for="company in companies" :key="company.id" :value="company.id">
                              {{ company.company_name }}
                            </option>
                          </select>
                          <v-errors :errors="errorFor('company_id')"></v-errors>
                        </div>
                      </div>
                    </div>
                    <div class="col_3 m-auto">
                      <button class="btn btn_primary" @click="openCompanyModal">Add New</button>
                    </div>
                  </div>
                  <div :class="['form_row', {'has_error': errorFor('phone')}]">
                    <label>Phone</label>
                    <div class="form_inline">
                      <input type="text" class="form_global" v-model="contact.phone">
                      <v-errors :errors="errorFor('phone')"></v-errors>
                    </div>
                  </div>
                  <div :class="['form_row', {'has_error': errorFor('photo')}]">
                    <label>Profile Image</label>
                    <div class="form_input center_horizontally">
                      <input ref="photo" type="file" class="form_global" accept="image/png, image/gif, image/jpeg" @input="onFileChange($event)">
                    </div>
                    <div class="form_row mt_10" v-if="tempFile">
                      <label></label>
                      <div class="inner_img p_relative display_inline">
                        <div class="cross_ic" @click.prevent="deleteFile">
                          <i class="fas fa-times"></i>
                        </div>
                        <img :src="tempFile" alt="" height="100" width="100">
                      </div>
                    </div>
                    <div v-else class="form_row mt_10">
                      <label></label>
                      <img v-if="contact.photo" :src="contact.photo" alt="" class="" width="100" height="100">
                    </div>
                  </div>
                </div>
              </div>
              <div :class="['form_row', {'has_error': errorFor('description')}]">
                <label>Description</label>
                <div class="form_inline">
                  <text-editor v-model:text="contact['description']" :id="'description_contract'"></text-editor>
                  <v-errors :errors="errorFor('description')"></v-errors>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom_btn">
        <button type="button" class="btn btn_transparent has_border_radius" @click="closeModal">Cancel</button>
        <button type="button" class="btn btn_black has_border_radius ml_10 width_100p" @click="submit" :disabled="isSubmitting">Save</button>
      </div>

      <BaseModal
          v-if="isShowModal"
          title="Add Company"
          :closeModal="closeCompanyModal"
          size="modal_600p"
      >
        <AddCompanyComponent
            :closeModal="closeCompanyModal"
            @send-data="receiveCreatedCompany"
        />
      </BaseModal>
    </div>
</template>

<script>
import TextEditor from "@/components/shared/TextEditor.vue";
import BaseModal from "@/components/BaseModal.vue";
import AddCompanyComponent from "@/components/shared/company/AddCompanyComponent.vue";
export default {
  name: 'AddContactComponent',
  components: {AddCompanyComponent, BaseModal, TextEditor},
  props: ['closeModal', 'addNewContract'],
  data() {
    return {
      isShowModal: false,
      isSubmitting: false,
      contact: {
        name: '',
        email: '',
        status: 1,
        company_id: '',
        title: '',
        phone: '',
        photo: '',
        description: ' ',
      },
      tempFile: null,
      companies: [],
    }
  },
  created() {
    this.getCompanies();
  },
  methods: {
    receiveCreatedCompany(data){
      if (data && data.id) {
        this.contact.company_id = data.id
        this.getCompanies();
      }
    },
    openCompanyModal(){
      this.isShowModal = true;
    },
    closeCompanyModal(){
      this.isShowModal = false;
    },
    getCompanies() {
      this.axios.get('/active-companies-for-relation').then(({data}) => {
        this.companies = data.data
      })
    },
    onFileChange(event){
      let files = event.target.files || event.dataTransfer.files;
      if (!files.length)
        return;

      let file = event.target.files[0]
      this.contact.photo = file

      this.tempFile = URL.createObjectURL(file);
    },
    deleteFile(){
      this.tempFile = null
      this.contact.photo = null
      this.$refs.photo.value = null;
    },
    submit() {
      this.allErrors = null;
      this.isSubmitting = true;

      let formData = new FormData()

      Object.keys(this.contact).forEach(key => {
        formData.append(key, this.contact[key] ? this.contact[key] : '');
      })

      this.axios.post('/contacts', formData)
          .then(({ data }) => {
            this.$emit('send-data', data.data);
            this.resetForm();
            this.showSuccessMsg("Contact Created Successfully!");
            this.closeModal()
          })
          .catch((err) => {
            this.allErrors = err.response.data.errors
            this.showFailMsg(err.response.data.message);
          })
          .finally(() => {
            this.isSubmitting = false;
          })
    },
    resetForm(){
      this.contact = {
        name: '',
        email: '',
        status: 1,
        company_id: '',
        title: '',
        phone: '',
        photo: '',
        description: '',
      }
    },
  }
}
</script>
